<template>
  <!-- eslint-disable vue/no-bare-strings-in-template -->
  <main class="facilitator projects">
    <table class="projects">
      <thead>
        <tr>
          <th>title</th>
          <th>status</th>
          <th class="align-right">price</th>
          <th class="align-right">requested</th>
          <th class="align-right">won</th>
          <th class="align-right">delivered</th>
          <th class="align-right">failure chance</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="project in projects" :key="project.sqid">
          <td class="title">
            <span class="title">{{ project.title }}</span>
            <span class="client">{{ project.client.title }}</span>
          </td>
          <td class="status">
            <strong :class="project.status.value">{{ project.status.label }}</strong>
          </td>
          <td class="align-right">
            <MoneyDisplay :value="project.price" />
          </td>
          <td class="align-right">{{ project.requestRound?.display ?? '-' }}</td>
          <td class="align-right">{{ project.quoteRound?.display ?? '-' }}</td>
          <td class="align-right">{{ project.deliveryRound?.display ?? '-' }}</td>
          <td class="align-right">
            <span v-if="project.status.value === 'active'">{{ project.failureChance }}%</span>
            <span v-else>-</span>
          </td>
        </tr>
      </tbody>
    </table>
  </main>
</template>

<script setup lang="ts">
import MoneyDisplay from '/@front:components/MoneyDisplay.vue'
import GameLayout from '/@front:layouts/game.vue'

defineOptions({
  layout: [GameLayout],
})

defineProps<{
  projects: any[]
}>()
</script>

<style scoped>
td.title {
  & .client {
    display: block;
    color: var(--gray-500);
    font-size: 0.875em;
  }
}
</style>
